import {Component, InputComponent, Object3D, property} from '@wonderlandengine/api';

import {vec3} from 'gl-matrix';
export class SnapRotate extends Component {
    static TypeName = 'snap-rotate';

    @property.object({required: true})
    player!: Object3D;

    @property.int(30)
    degrees = 30;

    input: InputComponent;
    snapped: boolean;

    start() {
        this.input = this.object.getComponent(InputComponent);
        this.snapped = false;
    }

    update(dt) {
        if (!this.input.xrInputSource) {
            return;
        }

        const currentAxis = this.input.xrInputSource.gamepad.axes[2];
        if (currentAxis > -0.2 && currentAxis < 0.2) {
            this.snapped = false;
            return;
        }
        if (Math.abs(currentAxis) < 0.8) {
            return;
        }
        let lastHeadPos = vec3.create();
        this.player.getTranslationWorld(lastHeadPos);

        if (currentAxis < -0.8 && !this.snapped) {
            this.player.rotateAxisAngleDeg([0, 1, 0], this.degrees);
            this.snapped = true;
        }

        if (currentAxis > 0.8 && !this.snapped) {
            this.player.rotateAxisAngleDeg([0, 1, 0], -this.degrees);
            this.snapped = true;
        }

        let currentHeadPos = vec3.create();
        this.player.getTranslationWorld(currentHeadPos);
        let newPos = vec3.create();
        vec3.sub(newPos, lastHeadPos, currentHeadPos);
        this.player.translate(newPos);
    }
}
